import e from"react";import{Container as r}from"./styles.js";const t=({as:t="div",...a})=>e.createElement(r,{as:t,...a});t.displayName="Card";export{t as Card};
//# sourceMappingURL=Card.js.map
